export const SEATS_STEP = "SEATS_STEP";
export const SHIFT_STEP = "SHIFT_STEP";
export const OPTIONS_STEP = "OPTIONS_STEP";
export const CONTACT_STEP = "CONTACT_STEP";
export const CONFIRM_STEP = "CONFIRM_STEP";
export const SET_STEP = "SET_STEP";

export const ORDER_MENU_STEP = "ORDER_MENU_STEP";
export const ORDER_SHIFT_STEP = "ORDER_SHIFT_STEP";
export const ORDER_CONTACT_STEP = "ORDER_CONTACT_STEP";
export const ORDER_CONFIRM_STEP = "ORDER_CONFIRM_STEP";
export const ORDER_CHECKOUT_STEP = "ORDER_CHECKOUT_STEP";
export const ORDER_BANCONTACT_STEP = "ORDER_BANCONTACT_STEP";
export const ORDER_CREDIT_CARD_STEP = "ORDER_CREDIT_CARD_STEP";
export const ORDER_UPON_PICKUP_PAYMENT_STEP = "ORDER_UPON_PICKUP_PAYMENT_STEP";
export const SET_ORDER_STEP = "SET_ORDER_STEP";

export const onNextStep = () => {
    return (dispatch, getState) => {
        const current_step = getState().uiReducer.step;
        let step = SEATS_STEP;
        switch (current_step) {
            case SEATS_STEP:
                step = SHIFT_STEP;
                break;
            case SHIFT_STEP:
                step = OPTIONS_STEP;
                break;
            case OPTIONS_STEP:
                step = CONTACT_STEP;
                break;
            case CONTACT_STEP:
                step = CONFIRM_STEP;
                break;
        }
        dispatch({type: SET_STEP, step: step});
    }
};

export const onPreviousStep = () => {
    return (dispatch, getState) => {
        const current_step = getState().uiReducer.step;
        let step = SEATS_STEP;
        switch (current_step) {
            case SHIFT_STEP:
                step = SEATS_STEP;
                break;
            case OPTIONS_STEP:
                step = SHIFT_STEP;
                break;
            case CONTACT_STEP:
                step = OPTIONS_STEP;
                break;
            case CONFIRM_STEP:
                step = CONTACT_STEP;
                break;
        }
        dispatch({type: SET_STEP, step: step});
    }
};

export const goToStep = (step) => {
    return (dispatch, getState) => {
        dispatch({type: SET_STEP, step: step});
    }
};

export const onNextOrderStep = () => {
    return (dispatch, getState) => {
        const current_step = getState().uiReducer.orderStep;
        let step = ORDER_MENU_STEP;
        switch (current_step) {
            case ORDER_MENU_STEP:
                step = ORDER_SHIFT_STEP;
                break;
            case ORDER_SHIFT_STEP:
                step = ORDER_CONTACT_STEP;
                break;
            case ORDER_CONTACT_STEP:
                step = ORDER_CONFIRM_STEP;
                break;
            case ORDER_CONFIRM_STEP:
                step = ORDER_CHECKOUT_STEP;
                break;
        }
        dispatch({type: SET_ORDER_STEP, step: step});
    }
};

export const onPreviousOrderStep = () => {
    return (dispatch, getState) => {
        const current_step = getState().uiReducer.orderStep;
        let step = ORDER_MENU_STEP;
        switch (current_step) {
            case ORDER_SHIFT_STEP:
                step = ORDER_MENU_STEP;
                break;
            case ORDER_CONTACT_STEP:
                step = ORDER_SHIFT_STEP;
                break;
            case ORDER_CONFIRM_STEP:
                step = ORDER_CONTACT_STEP;
                break;
            case ORDER_CHECKOUT_STEP:
                step = ORDER_CONFIRM_STEP;
                break;
        }
        dispatch({type: SET_ORDER_STEP, step: step});
    }
};

export const goToOrderStep = (step) => {
    return (dispatch, getState) => {
        dispatch({type: SET_ORDER_STEP, step: step});
    }
};


// WEBPACK FOOTER //
// ./src/store/actions/ui.js